import _ from 'lodash'
import React, { useContext, useState } from 'react'
import { Icon, Label, Popup, Segment } from 'semantic-ui-react'
import { gameScoringTypes } from '../../cnr/reducers/SportsSeasonReducer'
import { SportsSeasonContext } from 'projectSpecific/sports/cnr/contexts/SportsSeasonContext'

const _usePopup = false
const _size = 'small'

const StandingsLegend = (props) => {

  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state } = sportsSeasonContext ?? {}
  const { currentSeason_info, details_info } = sportsSeason_state ?? {}
  const { details, sectionPlayoffTeams } = details_info ?? {};
  const { gameScoringType } = currentSeason_info ?? {};
  const { playoffTeamsPerSection } = details ?? {};

  const [showLegend, setShowLegend] = useState()

  const handleShowLegend = () => setShowLegend(!showLegend)

  if (!sectionPlayoffTeams) return;

  const groupedByPlayoffTeams = _.groupBy(Object.entries(sectionPlayoffTeams), ([, value]) => value);

  const playoffCounts = {}

  _.forEach(sectionPlayoffTeams, (teamCount, key) => {
    if (!playoffCounts[teamCount]) { playoffCounts[teamCount] = [] }
    playoffCounts[teamCount].push(key)
  })

  // If you want it in a more readable format, you can map the result back to an object or any other format:
  const result = Object.entries(groupedByPlayoffTeams).reduce((acc, [key, teams]) => {
    acc[key] = teams.map(([numTeams]) => numTeams);
    return acc;
  }, {});

  let resultString = ''

  // Create the string
  _.map(result, (r, key) => {
    if (_.isEmpty(resultString)) {
      resultString += key
    } else {
      resultString += ', ' + key
    }
  })

  const resultStrings = {}

  // Create the string
  _.forEach(playoffCounts, (pc, pcKey) => {
    let resultString2 = ''
    _.forEach(pc, (pcc, k) => {
      resultString2 += pcc + ', '
    })
    resultString2 = resultString2.substring(resultString2, resultString2.length - 2)
    resultStrings[pcKey] = resultString2
  })


  const ppp = () => {
    const xxx = _.map(resultStrings, (rs, rsk) => (
      <Label size={_size}>{'Teams per Section (' + rs + ') '}{' Playoff Spots: ' + rsk}</Label>
    ))
    return xxx
  }

  let allowExtra = false

  switch (gameScoringType) {
    case gameScoringTypes.match:
    case gameScoringTypes.matchPoints:
      allowExtra = true
      break;
    default:
  }

  const content = () => <Segment basic>
    <Label style={{ width: '100%', color: 'white' }} size={_size} onClick={() => { handleShowLegend() }}>{'Legend'}<Icon style={{ float: 'right' }} name={showLegend ? 'caret down' : 'caret right'} /> </Label>
    <Segment basic className='standings-legend' inverted style={{ display: showLegend ? 'flex' : 'none', overflow: 'auto', height: '200px' }}>
      <Label size={_size}>{'Playoff Locked'}</Label>
      <Label size={_size}>{'Playoff Position'}{' '}{'(Top ' + resultString + ')'}</Label>
      <Label size={_size}>Non Playoff Position</Label>
      <Label size={_size}>Non Playoff</Label>
      <Label size={_size}>Previous Win</Label>
      <Label size={_size}>Previous Loss</Label>
      <Label size={_size}>Section Match</Label>
      {ppp()}
      <Label size={_size}>W - Wins</Label>
      <Label size={_size}>L - Losses</Label>
      {allowExtra && <Label size={_size}>{'P - Points'}{' '}{'(*not is use for official standings)'}</Label>}
      {allowExtra && <Label size={_size}>Win 3-0 or 3-1: 3-Points</Label>}
      {allowExtra && <Label size={_size}>Win 3-2: 2-Points</Label>}
      {allowExtra && <Label size={_size}>Loss 3-2: 1-Point</Label>}
      {allowExtra && <Label size={_size}>Loss 3-0 or 3-1: 0-Points</Label>}
    </Segment>
  </Segment>

  return _usePopup ? <Popup
    className='standings-legend-pop'
    content={content()}
    on='click'
    position='left center'
    trigger={<Icon className='standings-legend-icn' name='info' inverted circular color={'blue'} />}
  /> : content()
}

export default StandingsLegend
